import { FC } from "react";
import { FlightType } from "src/Modules/Flights/constants";
import { FlightInclusions, FlightPath } from "./components";
import { Divider } from "antd";
import { useTranslation } from "react-i18next";
import ImageWithEmptyFallback from "@Components/ImageWithEmptyFallback/ImageWithEmptyFallback";

const FlightCard: FC<{ flight: FlightType }> = ({ flight }) => {
  const { t } = useTranslation();
  return (
    <div className="border-border-default bg-background-default flex w-full flex-col gap-4 rounded-xl border p-4">
      <div className="flex w-full items-center gap-3">
        <div className="flex size-8 shrink-0 items-center justify-center overflow-hidden">
          <ImageWithEmptyFallback src={flight.airlineImage} className="h-full w-full rounded-sm" />
        </div>
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <span className="text-font-default font-semibold">{flight.airline}</span>
          {flight.flightNumber && (
            <>
              <span className="bg-icon-subtle size-1 rounded-full" />
              <span className="text-font-subtle font-medium">{t("Flights.details.flightPath.flightNumber", { number: flight.flightNumber })}</span>
            </>
          )}
        </div>
      </div>

      <FlightPath flight={flight} />

      <Divider className="m-0!" />
      <div className="flex w-full flex-1 items-center justify-between gap-2">
        <FlightInclusions
          flight={flight}
          className="text-font-subtle md:gap-3!"
          itemClassName="border-border-default flex-none! not-last:border-e not-last:pe-3"
        />
      </div>
    </div>
  );
};

export default FlightCard;
